const urlToFile = async (url, fileName, type = 'image/jpeg') => {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type,
  };
  return new File([data], fileName, metadata);
};

export default urlToFile;
